import React, { Component } from 'react';
import { BrowserRouter, Switch, Route, Redirect, Link, withRouter, useRouteMatch, useParams } from "react-router-dom";
import Contests from './ContestPage';
import Problemlist from './ProblemList';
import TermsOfService from './Terms';
import PrivacyPolicy from './Privacy';
import Landing from './Landing';
import ComingSoon from './ComingSoon';
import ErrorPage from './404Page';
import ProtectedRoute from './partials/ProtectedRoute';
import MerchandiseStore from '../Pages/MerchandiseStore/MerchandiseStore';
import Checkout from '../Pages/Checkout/Checkout';
import Transaction from '../Pages/Transaction/Transaction';
import ContestDesc from './ContestDesc';
import Cancellation from './Cancellation';
import ProblemSolving from './ProblemSolving';
import axios from 'axios';

import ProblemList from '../Pages/ProblemList/ProblemList';
class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liveContests: [],
      upcomingContests: [],
      pastContests: [],
      allContests: [],
    }
  }
  componentDidMount() {
    this.getLiveContests();
    this.getPastContests();
    this.getUpcomingContests();
  }
  getLiveContests = async () => {
    try {
      const res = await axios.get(`https://server.codeium.tech/contest/ongoing`);
      this.setState({ liveContests: res.data.msg, allContests: this.state.allContests.concat(res.data.msg) });
    } catch (err) {
      this.setState({ liveContests: [] });
    }
  };
  getUpcomingContests = async () => {
    try {
      const res = await axios.get(`https://server.codeium.tech/contest/upcoming`);
      this.setState({ upcomingContests: res.data.msg, allContests: this.state.allContests.concat(res.data.msg) });
    } catch (err) {
      // console.log(err);
      // console.log("failed upcoming");
      // this.setState({ upcomingContests: [] });
    }
  }
  getPastContests = async () => {
    try {
      const res = await axios.get(`https://server.codeium.tech/contest/past`);
      this.setState({ pastContests: res.data.msg, allContests: this.state.allContests.concat(res.data.msg) });
    } catch (err) {
      // console.log(err);
    }
  }

  render() {
    const ContestList = () => {
      return (
        <Contests
          ongoing={this.state.liveContests}
          past={this.state.pastContests}
          upcoming={this.state.upcomingContests}
        />);
    }
    const { path } = this.props.match;

    return (
      <>
        <Switch>
          <Route path="/store" component={MerchandiseStore} />
          <Route exact path="/checkout" component={Checkout} />
          <Route path="/transaction" component={Transaction} />
          <Route exact path="/" component={Landing} />
          <Route path="/contests" exact component={() => <ContestList />} />
          <Route path="/problems" exact component={() => <Redirect to="/comingsoon"/>} />
          <Route exact path="/privacypolicy" component={PrivacyPolicy} />
          <Route exact path="/termsofservice" component={TermsOfService} />
          <Route exact path='/contests/:contestId' render={({ match }) => <ContestDesc match={match}
            contest={this.state.allContests.filter((contest) => contest.contest_id.trim() === match.params.contestId.trim())[0]}
          />} />
          <ProtectedRoute exact path="/contests/:contestId/problems" exact component={ProblemList} />
          <ProtectedRoute exact path='/contests/:contestId/problems/:problemId' component={ProblemSolving} />
          <Route exact path="/comingsoon" exact component={ComingSoon} />
          <Route exact path="/404Page" exact component={ErrorPage} />
          <Route path="/checkout/cancellation" component={Cancellation} />
          <Redirect to="/contests" />
        </Switch>
      </>
    );
  }
}
export default withRouter(MainPage);